// src/components/cards/shared/CardElements.tsx
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

// Wraps card content + footer in a flex column that fills remaining viewport height
export const CardFooterContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: 0,
});

// Fills remaining space below card content; stays at minHeight on tall content
export const CardFooter = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'minHeight' &&
    prop !== 'mobileMinHeight' &&
    prop !== 'backgroundColor' &&
    prop !== 'borderTop',
})<{
  minHeight?: string;
  mobileMinHeight?: string;
  backgroundColor?: string;
  borderTop?: string;
}>(
  ({
    minHeight = '8rem',
    mobileMinHeight = '5rem',
    backgroundColor = 'transparent',
    borderTop = 'none',
  }) => ({
    flex: 1,
    minHeight: mobileMinHeight,
    backgroundColor,
    borderTop,
    '@media (min-width: 600px)': {
      minHeight,
    },
  })
);
